const clearSchemaFields = [
  "b1_emp_name",
  "b2_emp_dba",
  "b3_emp_address_1",
  "b4_emp_address_2",
  "b5_emp_city",
  "b6_emp_state_id",
  "b7_emp_zip",
  "b8_emp_country_id",
  "b9_emp_province",
  "b10_emp_phone",
  "b11_emp_phone_ext",
  "b12_emp_fein",
  "b13_emp_naics",
  "b13_emp_naics_description",

  "c1_poc_last",
  "c2_poc_first",
  "c3_poc_middle",
  "c4_poc_title",
  "c5_poc_address_1",
  "c6_poc_address_2",
  "c7_poc_city",
  "c8_poc_state_id",
  "c9_poc_zip",
  "c10_poc_country_id",
  "c11_poc_province",
  "c12_poc_phone",
  "c13_poc_phone_ext",
  "c14_poc_email",
  "d1_agent_type_id",
  "d2_agent_last",
  "d3_agent_first",
  "d4_agent_middle",
  "d5_agent_address_1",
  "d6_agent_address_2",
  "d7_agent_city",
  "d8_agent_state_id",
  "d9_agent_zip",
  "d10_agent_country_id",
  "d11_agent_province",
  "d12_agent_phone",
  "d13_agent_phone_ext",
  "d14_agent_email",
  "d15_agent_firm_name",
  "d16_agent_firm_fein",
  "d17_agent_bar_number",
  "d18_agent_court_state_id",
  "d19_agent_court_name",

  "ea1_soc_code",
  "ea2_soc_title",
  "ea3_pwd_number",
  "ec9_is_multiple_locations",
  "eb1_job_title",
  "eb5_job_duties",
  "eb8_education_id",
  "eb12_special_requirements",
  "eb9_training_months",
  "eb11_is_supervision",
  "eb11a_number_supervised",
  "eb10_experience_months",
  "ec1_work_address_1",
  "ec2_work_address_2",
  "ec3_work_city",
  "ec4_work_state_id",
  "ec5_work_zip",
  "ec7_pay_rate_id",
  "a6_9141",
  "appx_b_locations",
];

const clearFileFields = [
  "a6_emergency_justification",
  "b16_contract_attached",
  "d20_agent_agreement_attached",
  "ef_1_assurance_attached",
  "ef_2_assurance_attached",
];

export default {
  name: "Nature of the CW-1 Application",
  prefix: "A",
  pageInfo: {
    text: `<p><b>IMPORTANT:</b>  Employers and authorized preparers must read these instructions carefully before completing the Form ETA-9142C, CW-1 Application for Temporary Employment Certification and Appendices A to C. These instructions contain full explanations of the questions and attestations that make up the Form ETA-9142C and Appendices A to C.<b><i>In accordance with Federal Regulations, incomplete or obviously inaccurate applications will not be certified by the Department of Labor. Those items marked with an asterisk (*) are required and must be completed. Items marked with a section symbol (§) are conditional and must be completed if applicable.</i></b><br><br>Anyone, who knowingly and willingly furnishes any materially false information in the preparation of Form ETA-9142C and any supporting documentation, or aids, abets, or counsels another to do so is committing a federal offense punishable by fine, imprisonment, or both (18 U.S.C. §§ 2, 1001). Other penalties apply as well to fraud or misuse of this immigration document and to perjury with respect to this form (18 U.S.C. §§ 1546, 1621).`,
    coloring: "grey",
    read_more: true,
    character_limit: 665,
  },
  sections: [
    {
      name: "Type of Application",
      fields: [
        {
          isGroup: {
            code: "A.1",
            label:
              'Is the employer seeking to employ any CW-1 workers under this application who will be <u>exempt</u> from the statutory numerical limit, or "cap," on the total number of foreign nationals who may be issued an CW-1 visa or otherwise granted CW-1 status?',
            machine_name: "a1_application_type",
            validate: ["required"],
            tooltip: `As a CW-1 employer, enter whether this application is for "New employment" or for a "Renewal of approved employment."`,
            fields: [
              {
                widget: "radio",
                choice: "New employment",
                value: "New employment",
                clearSchema: ["a2_permit_renewal_date"],
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Renewal of approved employment",
                value: "Renewal of approved employment",
                validate: ["required"],
              },
            ],
          },
        },
        {
          code: "A.2",
          machine_name: "a2_permit_renewal_date",
          widget: "date",
          label:
            "If “Renewal of approved employment” is marked in Question A.1, enter the date on which the CW-1 visa status of the nonimmigrant worker(s) will expire.",
          validate: ["required"],
          isVisible: {
            when: "a1_application_type",
            is: "Renewal of approved employment",
          },
          tooltip: `If this application is for "Renewal of approved employment," enter the date(s) which the CW-1 visa classification status will expire for the nonimmigrant worker(s) to be employed under this labor certification. Use a month/day/full year (MM/DD/YYYY)format.`,
        },
      ],
    },
    {
      name: "Long-Term Worker",
      fields: [
        {
          isGroup: {
            code: "A.3",
            label:
              "Is the employer seeking to employ a long-term worker who was previously issued a CW-1 visa or otherwise granted CW-1 status, as defined in 20 CFR 655.402?",
            machine_name: "a3_is_long_term",
            validate: ["required"],
            tooltip: `Enter whether the employer is seeking to employ a long-term worker previously granted a CW-1 visa or a CW-1 status as defined by 20 CFR 655.502 by indicating "Yes" or "No."`,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
              },
            ],
          },
        },
      ],
    },
    {
      name: "Cap-Exempt Worker",
      fields: [
        {
          isGroup: {
            code: "A.4",
            label:
              "Will any of the CW-1 workers employed under this application be exempt from the statutory numerical limit, or “cap,” on the total number of foreign nationals who may be issued a CW-1 visa or otherwise granted CW-1 status?",
            machine_name: "a4_is_cap_exempt",
            validate: ["required"],
            tooltip: `Enter whether any CW-1 workers employed under this application will be <u>exempt</u> from the statutory numerical limit on the total number of foreign nationals who may be issued a CW-1 visa by indicating "Yes" or "No." For more information on exemptions to the CW-1 visa "cap," please go to <a>www.uscis.gov</a>`,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
              },
            ],
          },
        },
      ],
    },
    {
      name: "Emergency Situation",
      divider: "hide",
      fields: [
        {
          isGroup: {
            code: "A.5",
            label:
              "Is the employer requesting to waive the requirement to obtain a valid PWD prior to the filing of this application due to an emergency situation, as set forth in 20 CFR 655.422?",
            machine_name: "a5_is_emergency",
            validate: ["required"],
            tooltip: `Enter whether the employer is requesting to waive the requirement set forth in 20 CFR 655.422, to obtain a valid Prevailing Wage Determination (PWD) prior to the filing of the CW-1 Application for Temporary Employment Certificaiton, by indicating "Yes" or "No." <strong>Please note:</strong> if "Yes" is marked, sections A.6 and A.7 <u>must</u> be completed.`,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
                clearSchema: clearSchemaFields,
                clearTableErrors: ["appx_b"],
                clearFiles: clearFileFields,
                setSchema: [
                  {
                    set: "appx_b",
                    to: [],
                  },
                ],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
                clearSchema: clearSchemaFields,
                clearTableErrors: ["appx_b"],
                clearFiles: clearFileFields,
                setSchema: [
                  {
                    set: "appx_b",
                    to: [],
                  },
                ],
              },
            ],
          },
        },
      ],
    },
    {
      name: "Document Upload - Emergency Situation Justification",
      isVisible: {
        when: "a5_is_emergency",
        is: "YES",
      },
      divider: "hide",
      fields: [
        {
          label: `A statement justifying the employer's emergency situation is attached to this application.<br><br>Only .pdf, .doc, .docx, .txt, .xls, .xlsx files under 30 MB can be uploaded.`,
          machine_name: "a6_emergency_justification",
          name: "Emergency Filing Justification",
          widget: "file_upload",
          fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
          validate: ["required", "checkValue"],
        },
      ],
    },
    {
      coloring: "blue",
      isVisible: {
        when: "a5_is_emergency",
        is: ["YES", "NO"],
        operator: "||",
      },
      name: "Completed Form ETA-9141C",
      fields: [
        {
          machine_name: "a6_9141",
          widget: "pw_lookup",
          label:
            "Locate your Form ETA-9141, Application for Prevailing Wage Determination (PWD) below. *",
          validate: [
            {
              requiredWithCustomMessage:
                "You must link a prevailing wage determination to this case.",
            },
            "pNumberCheck",
          ],
          tooltip:
            "Select one to three 14-digit PWD numbers assigned by the National Prevailing Wage Center for the job opportunity listed on the application.",
          info: "If you do not have a relevant Form ETA-9141, Application for Prevailing Wage Determination, please complete one and return to this form once you have submitted.",
          pw_lookup: {
            formType: {
              this: "9141C",
              to: "9142C",
            },
            PWFields: {
              PWLinkingFields: ["a6_9141"],
              extraFieldsToSetPrimaryPW: ["ea3_pwd_number"], // populate primary pw elsewhere
            },
            worksiteFields: {
              importedWorksites: "appx_b",
              chosenWorksites: "appx_b_locations",
            },
            emergencyField: "a5_is_emergency",
            buttonPrimary: "PWD Case Lookup",
            socField: "ea1_soc_code",
            feinField: "b12_emp_fein",
          },
        },
      ],
    },
  ],
};
